import React, { useState } from 'react';
import type { FaqItem } from '../data/faqs';

/** Question rows; each opens its answer in place. */
export function Faq({
  items
}: {
  items: FaqItem[];
}) {
  const [open, setOpen] = useState<Record<string, boolean>>({});
  return <div className="faq" data-id="element-50" data-mp="1lc1xz6j6wro0">
      {items.map((item, i) => {
      const isOpen = !!open[item.q];
      const id = `faq-a-${i}`;
      return <div className="faq-i" key={item.q} data-id="element-51" data-mp="2e0zfv8jhomg8" data-mpi={i}>
            <button type="button" className="faq-q" aria-expanded={isOpen} aria-controls={id} onClick={() => setOpen(prev => ({
          ...prev,
          [item.q]: !prev[item.q]
        }))} data-id="element-52" data-mp="2dzocvaxvbiq6">
              <span data-id="element-53" data-mp="1z3ozplvwise6">{item.q}</span>
              <span className="pm" aria-hidden="true" data-id="element-54" data-mp="1z2nj71w49dp2">
                {isOpen ? '–' : '+'}
              </span>
            </button>
            {isOpen && <div className="faq-a" id={id} data-id="element-55" data-mp="nnifbuk9193v">
                {item.a}
              </div>}
          </div>;
    })}
    </div>;
}